<template>
<div class="chapter">
<div class="inner_page">
<h1>Surrounded by Enemies</h1>
<h3 class="sigil_not_in_toc" style="text-align: center;"><i>A Breakpoint Novel</i></h3>
<h2 class="sigil_not_in_toc">Bryce Zabel</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TitlePage.vue?26549b42